<template>
  <div class="pa-4 scrap-motivo-wrapper">
    <!-- Loading central con efecto transparente y sombra (Consulta y Generación de PDF) -->
    <v-overlay
      v-if="cargandoReporte || loaderScrapPdf"
      :value="cargandoReporte || loaderScrapPdf"
      z-index="9999"
      opacity="0.4"
      class="consulta-overlay-container"
    >
      <div class="consulta-loader-card">
        <div class="consulta-loader-spinner-wrapper mb-4">
          <v-progress-circular
            indeterminate
            :color="loaderScrapPdf ? '#e11d48' : '#2563eb'"
            :size="64"
            :width="5"
          ></v-progress-circular>
          <div class="consulta-loader-inner-icon">
            <v-icon :color="loaderScrapPdf ? '#e11d48' : '#2563eb'" size="26">
              {{
                loaderScrapPdf ? "mdi-file-pdf-box" : "mdi-delete-alert-outline"
              }}
            </v-icon>
          </div>
        </div>

        <div class="consulta-loader-title font-weight-bold">
          {{
            loaderScrapPdf
              ? "Generando Reporte PDF"
              : "Procesando Reporte Scrap por Motivo"
          }}
        </div>
        <div class="consulta-loader-subtitle mt-1">
          {{
            loaderScrapPdf
              ? loaderScrapPdfMensaje ||
                "Generando reporte PDF en segundo plano..."
              : "Procesando neumáticos en scrap. Por favor, espere unos momentos..."
          }}
        </div>

        <!-- Botón Cancelar sólo para generación de PDF -->
        <div v-if="loaderScrapPdf" class="mt-4">
          <v-btn
            small
            depressed
            color="#fee2e2"
            class="text-caption font-weight-bold red--text text--darken-3 px-4 rounded-pill"
            @click="cerrarScrapVisor"
          >
            <v-icon left x-small>mdi-close</v-icon>
            Cancelar&nbsp;&nbsp;&nbsp;
          </v-btn>
        </div>
      </div>
    </v-overlay>

    <v-btn @click="$router.back()" class="back-btn mb-4">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>
    <v-col lg="12" class="pa-0">
      <v-row justify="center">
        <v-col lg="12">
          <v-card class="modern-report-card elevation-2 mb-4">
            <!-- Header moderno con gradiente y botón de ayuda -->
            <div class="report-header-banner">
              <div class="d-flex align-center header-main-info">
                <div class="header-icon-box mr-3 flex-shrink-0">
                  <v-icon color="white">mdi-delete-alert-outline</v-icon>
                </div>
                <div class="header-text-block">
                  <div
                    class="font-weight-bold white--text header-company-title"
                  >
                    Neumáticos en Scrap por Motivo
                  </div>
                  <div class="header-report-subtitle">
                    Análisis y distribución mensual de neumáticos dados de baja
                    según causas de scrap
                  </div>
                </div>
              </div>

              <div
                class="header-help-btn ml-auto flex-shrink-0 d-flex align-center"
              >
                <!-- Chip resumen en cabecera si hay resultados -->
                <v-chip
                  v-if="visualizarGrafico && totalgeneral > 0"
                  small
                  class="d-none d-sm-inline-flex mr-2 summary-header-chip"
                >
                  <v-icon left x-small color="amber lighten-2">mdi-tire</v-icon>
                  Total Scrap: <strong>{{ totalgeneral }}</strong>
                </v-chip>

                <!-- Botón de ayuda -->
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-1 btn-circle-tooltip"
                      icon
                      dark
                      target="_blank"
                      :href="
                        global && global.helpdesk_url
                          ? global.helpdesk_url + 'reporte-scrap-motivo'
                          : '#'
                      "
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon size="22" color="amber lighten-2"
                        >mdi-help-circle-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>¿Necesitas ayuda?</span>
                </v-tooltip>
              </div>
            </div>

            <!-- Cuerpo del Reporte -->
            <v-card-text class="pa-4 pa-md-5">
              <!-- Card de Filtros de Búsqueda -->
              <v-card
                class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1"
              >
                <div
                  class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
                >
                  <div class="d-flex align-center">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-filter-variant</v-icon
                    >
                    <span
                      class="font-weight-bold text-caption text-uppercase text--primary"
                    >
                      Filtros de Búsqueda
                    </span>
                  </div>

                  <div class="d-flex align-center" v-if="reporteConsultado">
                    <v-chip
                      x-small
                      color="primary lighten-4"
                      class="primary--text font-weight-bold"
                    >
                      <v-icon left x-small>mdi-check-circle</v-icon>
                      Filtro aplicado
                    </v-chip>
                  </div>
                </div>

                <div class="pa-4 pa-md-5">
                  <v-row align="center">
                    <!-- Cliente -->
                    <!-- <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        outlined
                        dense
                        hide-details="auto"
                        label="Cliente"
                        :value="
                          Cliente && Cliente.razon_social
                            ? Cliente.razon_social
                            : ''
                        "
                        readonly
                        prepend-inner-icon="mdi-domain"
                        class="field-custom field-readonly"
                      ></v-text-field>
                    </v-col> -->

                    <!-- RUC -->
                    <!-- <v-col cols="12" sm="6" md="3" lg="2">
                      <v-text-field
                        outlined
                        dense
                        hide-details="auto"
                        label="RUC"
                        :value="Cliente && Cliente.ruc ? Cliente.ruc : ''"
                        readonly
                        prepend-inner-icon="mdi-card-bulleted-outline"
                        class="field-custom field-readonly"
                      ></v-text-field>
                    </v-col> -->

                    <!-- Año -->
                    <v-col cols="12" sm="6" md="3" lg="3">
                      <v-autocomplete
                        outlined
                        dense
                        hide-details="auto"
                        :items="Years"
                        v-model="Item.year"
                        label="Año *"
                        placeholder="Seleccione año"
                        @change="onMeses(Item.year)"
                        prepend-inner-icon="mdi-calendar"
                        class="field-custom"
                      ></v-autocomplete>
                    </v-col>

                    <!-- Mes inicial -->
                    <v-col cols="12" sm="6" md="3" lg="3">
                      <v-autocomplete
                        outlined
                        dense
                        hide-details="auto"
                        :items="Meses"
                        item-text="mes"
                        item-value="numero_mes"
                        v-model="Item.month_init"
                        label="Mes inicial *"
                        placeholder="Seleccione mes inicial"
                        prepend-inner-icon="mdi-calendar-start"
                        class="field-custom"
                      ></v-autocomplete>
                    </v-col>

                    <!-- Mes final -->
                    <v-col cols="12" sm="6" md="3" lg="3">
                      <v-autocomplete
                        outlined
                        dense
                        hide-details="auto"
                        :items="Meses"
                        item-text="mes"
                        item-value="numero_mes"
                        v-model="Item.month_end"
                        label="Mes final"
                        placeholder="Mes final (opcional)"
                        clearable
                        prepend-inner-icon="mdi-calendar-end"
                        class="field-custom"
                      ></v-autocomplete>
                    </v-col>

                    <!-- Botones de Acción (Consultar y Exportar) -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                      lg="3"
                      class="d-flex align-center justify-end"
                    >
                      <v-btn
                        @click="consultarReporte()"
                        color="primary"
                        height="40"
                        class="filter-action-btn font-weight-bold flex-grow-1 mr-2 px-2"
                        :disabled="
                          !Item.year || !Item.month_init || cargandoReporte
                        "
                        :loading="cargandoReporte"
                      >
                        <v-icon left small>mdi-magnify</v-icon>
                        Consultar&nbsp;&nbsp;
                      </v-btn>

                      <v-btn
                        @click="abrirModalSeccionesExportar()"
                        color="error"
                        height="40"
                        class="filter-action-btn font-weight-bold flex-grow-1 px-2"
                        :disabled="
                          !reporteConsultado ||
                          cargandoReporte ||
                          !Item.year ||
                          !Item.month_init
                        "
                        :loading="loaderScrapPdf"
                      >
                        <v-icon left small>mdi-file-pdf-box</v-icon>
                        Exportar&nbsp;&nbsp;
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-card>

              <!-- Estado 1: Cargando datos -->
              <div
                v-if="cargandoReporte"
                class="chart-loading-state rounded-lg pa-10 d-flex flex-column align-center justify-center text-center my-4"
              >
                <v-progress-circular
                  indeterminate
                  size="52"
                  width="4"
                  color="primary"
                  class="mb-4"
                ></v-progress-circular>
                <div
                  class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-1"
                >
                  Consultando neumáticos en scrap...
                </div>
                <div class="text-caption grey--text text--darken-1">
                  Procesando datos mensuales, motivos de desecho y costos
                  asociados
                </div>
              </div>

              <!-- Estado 2: Sin consulta inicial -->
              <div
                v-else-if="!visualizarGrafico && !reporteConsultado"
                class="chart-empty-state rounded-lg pa-8 pa-md-12 d-flex flex-column align-center justify-center text-center my-4"
              >
                <div class="empty-state-icon-circle mb-4">
                  <v-icon size="48" color="primary lighten-1"
                    >mdi-delete-clock-outline</v-icon
                  >
                </div>
                <h3
                  class="text-h6 font-weight-bold grey--text text--darken-3 mb-2"
                >
                  Consulte el análisis de scrap por motivo
                </h3>
                <p
                  class="text-body-2 grey--text text--darken-1 max-width-480 mb-4"
                >
                  Seleccione el año y mes para obtener la distribución de
                  neumáticos dados de baja, análisis de causas y pérdidas
                  acumuladas.
                </p>
                <v-chip
                  outlined
                  small
                  color="primary"
                  class="font-weight-medium"
                >
                  <v-icon left x-small>mdi-filter-variant</v-icon>
                  Seleccione los filtros y presione "Consultar Reporte"
                </v-chip>
              </div>

              <!-- Estado 3: Sin registros encontrados para la búsqueda -->
              <div
                v-else-if="
                  !visualizarGrafico && reporteConsultado && !cargandoReporte
                "
                class="chart-empty-state rounded-lg pa-8 pa-md-12 d-flex flex-column align-center justify-center text-center my-4"
              >
                <div class="empty-state-icon-circle mb-4">
                  <v-icon size="48" color="amber darken-2"
                    >mdi-alert-circle-outline</v-icon
                  >
                </div>
                <h3
                  class="text-h6 font-weight-bold grey--text text--darken-3 mb-2"
                >
                  Sin datos de scrap encontrados
                </h3>
                <p
                  class="text-body-2 grey--text text--darken-1 max-width-480 mb-4"
                >
                  No se encontraron neumáticos en scrap registrados para el año
                  y meses seleccionados.
                </p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center" v-if="visualizarGrafico == true">
        <v-col cols="12">
          <v-card
            class="dashboard-chart-card rounded-lg overflow-hidden elevation-1 mb-4"
          >
            <v-toolbar
              height="52"
              color="#243042"
              dark
              flat
              class="px-3 px-sm-4 toolbar-responsive"
            >
              <v-icon small color="primary" class="mr-2"
                >mdi-calendar-month-outline</v-icon
              >
              <span
                class="font-weight-bold text-subtitle-2 text-sm-subtitle-1 text-truncate"
              >
                Distribución mensual según motivo de scrap
              </span>
            </v-toolbar>
            <v-container class="pa-3 pa-sm-4">
              <div v-if="visualizarGrafico == true && existInfoScrap == true">
                <!-- Indicador de scroll horizontal en celular -->
                <div
                  class="d-flex d-sm-none align-center text-caption primary--text mb-2 px-1"
                >
                  <v-icon x-small color="primary" class="mr-1"
                    >mdi-gesture-swipe-horizontal</v-icon
                  >
                  <span
                    >Desliza horizontalmente para ver todos los motivos</span
                  >
                </div>
                <div
                  class="table-responsive rounded border"
                  style="overflow-x: auto"
                >
                  <v-data-table
                    dense
                    :headers="headersDistribucion"
                    :items="itemsDistribucion"
                    hide-default-footer
                    disable-pagination
                    disable-sort
                    mobile-breakpoint="0"
                    style="min-width: 800px; width: 100%"
                    class="elevation-1 tabla-distribucion-moderna letra-10"
                    no-data-text="No hay datos disponibles"
                  >
                    <!-- Mes -->
                    <template v-slot:[`item.nombre`]="{ item }">
                      <span class="font-weight-bold grey--text text--darken-3">
                        {{ item.nombre }}
                      </span>
                    </template>

                    <!-- Total mes -->
                    <template v-slot:[`item.total_mes`]="{ item }">
                      <span class="black--text font-weight-bold">
                        {{ item.total_mes }}
                      </span>
                    </template>

                    <!-- Porcentaje mes -->
                    <template v-slot:[`item.porcentaje_mes`]="{ item }">
                      <span class="black--text font-weight-bold">
                        {{ item.porcentaje_mes }}
                      </span>
                    </template>

                    <!-- Filas de Totales en Pie de Tabla -->
                    <template v-slot:body.append>
                      <!-- Fila Total General -->
                      <tr class="fila-total-general">
                        <td class="text-center font-weight-bold py-2">
                          <div class="d-flex align-center justify-center">
                            <v-icon small color="primary" class="mr-1"
                              >mdi-sigma</v-icon
                            >
                            <span>Total general</span>
                          </div>
                        </td>
                        <td
                          v-for="(item, index) in totales_motivo"
                          :key="'tot-' + index"
                          class="text-center font-weight-bold py-2"
                        >
                          <span class="black--text">
                            {{ item }}
                          </span>
                        </td>
                        <td class="text-center py-2">
                          <span class="black--text">
                            {{ totalgeneral }}
                          </span>
                        </td>
                        <td class="text-center py-2">
                          <span class="black--text"> 100% </span>
                        </td>
                      </tr>

                      <!-- Fila Porcentaje -->
                      <tr class="fila-porcentaje-general">
                        <td
                          class="text-center font-weight-bold py-2 text-caption grey--text text--darken-2"
                        >
                          % Participación
                        </td>
                        <td
                          v-for="(item, index) in totales_motivo"
                          :key="'porc-' + index"
                          class="text-center py-2 text-caption font-weight-medium grey--text text--darken-3"
                        >
                          {{ calcularPorcentaje(item) }}
                        </td>
                        <td class="text-center py-2">
                          <span class="black--text font-weight-bold">
                            100%
                          </span>
                        </td>
                        <td class="text-center py-2 grey--text text--lighten-1">
                          -
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </div>
              <div v-else>
                <v-alert
                  colored-border
                  border="left"
                  color="orange darken-3"
                  icon="mdi-information-outline"
                  class="orange lighten-5 rounded-lg mb-4 pa-3 alert-icon-leyenda"
                  style="width: 100%"
                >
                  <v-row dense class="align-center">
                    <v-col cols="12">
                      <div class="d-flex align-center">
                        <div>
                          <span
                            class="grey--text text--darken-4 text-caption font-weight-medium"
                            >No se encontraron datos de neumáticos en
                            scrap.</span
                          >
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-alert>
              </div>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center" v-if="visualizarGrafico == true">
        <v-col cols="12">
          <v-card
            class="dashboard-chart-card rounded-lg overflow-hidden elevation-1 mb-4"
          >
            <v-toolbar
              height="52"
              color="#243042"
              dark
              flat
              class="px-3 px-sm-4 toolbar-responsive"
            >
              <v-icon small color="primary" class="mr-2">mdi-chart-pie</v-icon>
              <span
                class="font-weight-bold text-subtitle-2 text-sm-subtitle-1 text-truncate"
              >
                Resumen de inspección de análisis de scrap
              </span>
            </v-toolbar>
            <v-container class="pa-3 pa-sm-4">
              <v-row
                align="center"
                v-if="visualizarGrafico == true && existInfoScrap == true"
              >
                <v-col cols="12" md="6" lg="6">
                  <GraficoPie
                    IdGrafico="grafico_pastel_motivo_scrap"
                    :Labels="LabelsGraficoPie"
                    :DatosGrafico="DatosGraficoPie"
                    :BackgroundColor="coloresGrafico"
                    :ShowLegend="false"
                    Suffix="%"
                    :Height="$vuetify.breakpoint.xsOnly ? '320px' : '480px'"
                    v-if="
                      visualizarGrafico == true && DatosGraficoPie.length > 0
                    "
                  />
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <div
                    class="table-responsive rounded border"
                    style="overflow-x: auto"
                  >
                    <div class="tabla-distribucion-moderna elevation-1">
                      <table
                        class="letra-10"
                        style="width: 100%; min-width: 320px"
                      >
                        <thead>
                          <tr>
                            <th style="width: 60px" class="text-center">
                              Color
                            </th>
                            <th class="text-left">Motivo</th>
                            <th style="width: 85px" class="text-center">
                              Cantidad
                            </th>
                            <th style="width: 85px" class="text-center">
                              Porcentaje
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in ResumenMotivos"
                            :key="index"
                          >
                            <td
                              class="text-center"
                              style="vertical-align: middle"
                            >
                              <span
                                :style="{
                                  display: 'inline-block',
                                  width: '18px',
                                  height: '18px',
                                  borderRadius: '4px',
                                  backgroundColor: obtenerColorMotivo(index),
                                  verticalAlign: 'middle',
                                  boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                                  border: '1px solid rgba(0,0,0,0.15)',
                                }"
                              ></span>
                            </td>
                            <td
                              class="text-left font-weight-medium grey--text text--darken-3"
                            >
                              {{ item.motivo }}
                            </td>
                            <td
                              class="text-center font-weight-bold grey--text text--darken-4"
                            >
                              {{ item.cantidad }}
                            </td>
                            <td
                              class="text-center font-weight-bold grey--text text--darken-4"
                            >
                              {{ item.porcentajeStr }}
                            </td>
                          </tr>
                          <tr class="fila-total-general">
                            <td class="text-center py-2">
                              <v-icon small color="primary">mdi-sigma</v-icon>
                            </td>
                            <td class="text-left font-weight-bold py-2">
                              Total general
                            </td>
                            <td class="text-center font-weight-bold py-2">
                              {{ totalgeneral }}
                            </td>
                            <td class="text-center font-weight-bold py-2">
                              100%
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  lg="12"
                  class="mt-2"
                  v-if="motivoMayorScrap"
                >
                  <v-alert
                    dense
                    text
                    color="info"
                    icon="mdi-information-outline"
                    class="mb-0 text-center"
                  >
                    El mayor porcentaje de neumaticos retirados fueron por
                    <strong>{{ motivoMayorScrap.motivo }}</strong
                    >, con un alcance del
                    <strong>{{ motivoMayorScrap.porcentaje }}</strong
                    >.
                  </v-alert>
                </v-col>
              </v-row>
              <div v-else>
                <v-alert
                  colored-border
                  border="left"
                  color="orange darken-3"
                  icon="mdi-information-outline"
                  class="orange lighten-5 rounded-lg mb-4 pa-3 alert-icon-leyenda"
                  style="width: 100%"
                >
                  <v-row dense class="align-center">
                    <v-col cols="12">
                      <div class="d-flex align-center">
                        <div>
                          <span
                            class="grey--text text--darken-4 text-caption font-weight-medium"
                            >No se encontraron datos de neumáticos en
                            scrap.</span
                          >
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-alert>
              </div>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center" v-if="visualizarGrafico == true">
        <v-col cols="12">
          <v-card
            class="dashboard-chart-card rounded-lg overflow-hidden elevation-1 mb-4"
          >
            <v-toolbar
              height="52"
              color="#243042"
              dark
              flat
              class="px-3 px-sm-4 toolbar-responsive"
            >
              <v-icon small color="primary" class="mr-2"
                >mdi-clipboard-list-outline</v-icon
              >
              <span
                class="font-weight-bold text-subtitle-2 text-sm-subtitle-1 text-truncate"
              >
                Resumen de neumáticos inspeccionados en (SCRAP)
              </span>
            </v-toolbar>
            <v-container class="pa-3 pa-sm-4">
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="searchNeumaticos"
                    append-icon="mdi-magnify"
                    label="Buscar neumático..."
                    single-line
                    hide-details
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Indicador de scroll horizontal en celular -->
              <div
                class="d-flex d-sm-none align-center text-caption primary--text mt-3 mb-1 px-1"
              >
                <v-icon x-small color="primary" class="mr-1"
                  >mdi-gesture-swipe-horizontal</v-icon
                >
                <span>Desliza horizontalmente para ver todas las columnas</span>
              </div>

              <div
                class="table-responsive mt-2 rounded border"
                style="overflow-x: auto"
              >
                <v-data-table
                  dense
                  :headers="headersNeumaticos"
                  :items="NeumaticosScrap"
                  :search="searchNeumaticos"
                  :items-per-page="10"
                  mobile-breakpoint="0"
                  style="min-width: 1450px; width: 100%"
                  class="elevation-1 tabla-distribucion-moderna letra-10"
                  no-data-text="No hay datos disponibles"
                  no-results-text="No se encontraron registros coincidentes"
                  :footer-props="{
                    'items-per-page-text': 'Filas por página:',
                    'items-per-page-options': [10, 25, 50, 100],
                    'page-text': '{0}-{1} de {2}',
                  }"
                >
                  <template v-slot:[`item.nuevo`]="{ item }">
                    <span
                      :style="{
                        fontWeight: 'bold',
                      }"
                    >
                      {{ item.nuevo == 1 ? "ORIGINAL" : "REENCAUCHADO" }}
                    </span>
                  </template>
                  <template v-slot:[`item.empresa_reenc`]="{ item }">
                    {{ item.empresa_reenc || "-" }}
                  </template>
                  <template v-slot:[`item.izq`]="{ item }">
                    {{
                      item.ultima_inspeccion && item.ultima_inspeccion.exterior
                        ? item.ultima_inspeccion.exterior
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.der`]="{ item }">
                    {{
                      item.ultima_inspeccion && item.ultima_inspeccion.interior
                        ? item.ultima_inspeccion.interior
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.motivo_retiro`]="{ item }">
                    {{
                      item.historial && item.historial.motivo_retiro
                        ? item.historial.motivo_retiro
                        : "-"
                    }}
                  </template>
                  <template v-slot:[`item.motivo`]="{ item }">
                    {{ item.motivo || "-" }}
                  </template>
                  <template v-slot:[`item.cliente`]="{ item }">
                    {{ item.cliente || "-" }}
                  </template>
                  <template v-slot:[`item.remanente_original`]="{ item }">
                    {{ item.remanente_original || "-" }}
                  </template>
                  <template v-slot:[`item.remanente_final`]="{ item }">
                    {{ item.remanente_final || "-" }}
                  </template>
                  <template v-slot:[`item.remanente_limite`]="{ item }">
                    {{ item.remanente_limite || "-" }}
                  </template>
                  <template v-slot:[`item.precio`]="{ item }">
                    ${{ item.precio || "0.00" }}
                  </template>
                  <template v-slot:[`item.costo_perdido`]="{ item }">
                    ${{ item.costo_perdido || "0.00" }}
                  </template>
                  <template v-slot:[`item.image`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="info"
                          height="26"
                          depressed
                          class="px-3 font-weight-medium text-caption text-none rounded-pill elevation-1"
                          dark
                          @click="verImagen(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon left x-small
                            >mdi-image-multiple-outline</v-icon
                          >
                          Ver imagen
                        </v-btn>
                      </template>
                      <span>Ver imágenes y recomendación</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </div>
            </v-container>
            <v-col
              cols="12"
              md="12"
              lg="12"
              class="mt-2"
              v-if="motivoMayorScrap"
            >
              <v-alert
                dense
                text
                color="info"
                icon="mdi-information-outline"
                class="mb-0 text-center"
              >
                Se realizo el cálculo del costo de pérdida de los neumáticos
                adjunto, llegando a la conclusión de
                <strong>${{ costo_perdido_total }}</strong
                >.
              </v-alert>
            </v-col>
          </v-card>
        </v-col>
      </v-row>

      <!-- <v-row v-if="visualizarGrafico == true">
        <v-col cols="1" sm="1" md="1" class="mt-2">
          <v-btn color="success" @click="exportarAExcel" small>
            Exportar Excel
          </v-btn>
        </v-col>
      </v-row> -->

      <!-- Dialog Modal para Selección de Secciones al Exportar -->
      <v-dialog
        v-model="dialogSeccionesExportar"
        max-width="700px"
        persistent
        scrollable
        transition="dialog-transition"
      >
        <v-card class="overflow-hidden">
          <!-- Header con degradado premium -->
          <div
            class="pa-4 primary darken-2 white--text d-flex align-center justify-space-between"
            style="
              background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
            "
          >
            <div>
              <div class="text-h6 font-weight-bold white--text">
                Selección de Secciones a Exportar
              </div>
              <div
                class="caption text--lighten-3 blue-grey--text text--lighten-4"
              >
                Elija los componentes e índices que se incluirán en el reporte
                PDF
              </div>
            </div>
            <v-btn icon dark @click="dialogSeccionesExportar = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <!-- Barra de acciones y estado -->
          <div
            class="px-5 py-3 grey lighten-4 border-bottom d-flex align-center justify-space-between flex-wrap gap-2"
          >
            <div class="d-flex align-center">
              <v-chip color="primary" class="font-weight-bold mr-2" small label>
                <v-icon left x-small>mdi-check-all</v-icon>
                {{ seccionesSeleccionadas.length }} de
                {{ seccionesDisponibles.length }} secciones
              </v-chip>
              <span class="caption text--secondary hidden-xs-only">
                {{
                  seccionesSeleccionadas.length === seccionesDisponibles.length
                    ? "Todas las secciones incluidas"
                    : "Selección personalizada"
                }}
              </span>
            </div>
            <div class="d-flex align-center">
              <v-btn
                text
                x-small
                :color="todasSeccionesSeleccionadas ? 'error' : 'primary'"
                class="font-weight-bold"
                @click="toggleSeleccionarTodas()"
              >
                <v-icon left x-small>{{
                  todasSeccionesSeleccionadas
                    ? "mdi-checkbox-multiple-blank-outline"
                    : "mdi-checkbox-multiple-marked-outline"
                }}</v-icon>
                {{
                  todasSeccionesSeleccionadas
                    ? "Deseleccionar todo"
                    : "Seleccionar todo"
                }}
              </v-btn>
            </div>
          </div>

          <v-card-text
            class="pa-5"
            style="max-height: 65vh; background-color: #f8fafc"
          >
            <!-- Selector de Planta / Sede -->
            <div class="mb-4">
              <div
                class="caption font-weight-bold grey--text text--darken-2 mb-1"
              >
                Sede del Reporte
              </div>
              <v-autocomplete
                v-model="plantaSeleccionada"
                :items="listaPlantas"
                item-text="nombre"
                item-value="nombre"
                label="Seleccione una sede *"
                dense
                outlined
                hide-details="auto"
                :loading="cargandoPlantas"
                clearable
                no-data-text="No se encontraron plantas"
                class="rounded-lg bg-white"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ item.nombre }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="caption grey--text text--darken-1"
                      v-if="item.direccion"
                    >
                      <v-icon x-small class="mr-1">mdi-map-marker</v-icon>
                      {{ item.direccion }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <template v-slot:selection="{ item }">
                  <span class="font-weight-bold text-body-2">
                    {{ item.nombre }}
                  </span>
                  <span
                    class="caption grey--text text--darken-1 ml-2 text-truncate"
                    style="max-width: 380px"
                    v-if="item.direccion"
                  >
                    — {{ item.direccion }}
                  </span>
                </template>
              </v-autocomplete>
            </div>

            <div
              class="caption font-weight-bold grey--text text--darken-2 mb-2"
            >
              Secciones del Reporte
            </div>

            <v-row dense>
              <v-col
                cols="12"
                v-for="sec in seccionesDisponibles"
                :key="sec.id"
                class="mb-2"
              >
                <div
                  class="seccion-card-grupo rounded-lg border bg-white elevation-1 pa-3"
                  style="cursor: pointer; user-select: none"
                  @click="toggleSeccion(sec.id)"
                  :class="{
                    'seccion-simple-selected': seccionesSeleccionadas.includes(
                      sec.id,
                    ),
                  }"
                >
                  <div class="d-flex align-center">
                    <v-icon
                      :color="
                        seccionesSeleccionadas.includes(sec.id)
                          ? 'primary'
                          : 'grey darken-1'
                      "
                      class="mr-2"
                    >
                      {{
                        seccionesSeleccionadas.includes(sec.id)
                          ? "mdi-checkbox-marked"
                          : "mdi-checkbox-blank-outline"
                      }}
                    </v-icon>
                    <span
                      class="body-2 grey--text text--darken-3 font-weight-bold"
                    >
                      {{ sec.titulo }}
                    </span>
                  </div>
                  <div
                    v-if="sec.subsecciones && sec.subsecciones.length"
                    class="pl-8 pt-2"
                  >
                    <div
                      class="caption grey--text text--darken-1 font-weight-medium mb-1"
                    >
                      Contenido incluido:
                    </div>
                    <div class="d-flex flex-wrap">
                      <v-chip
                        v-for="(sub, i) in sec.subsecciones"
                        :key="i"
                        x-small
                        label
                        color="grey lighten-3"
                        class="mr-1 mb-1 grey--text text--darken-2"
                      >
                        {{ sub }}
                      </v-chip>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="px-5 py-3 white">
            <div class="caption grey--text text--darken-1 d-flex align-center">
              <v-icon x-small color="grey" class="mr-1"
                >mdi-information-outline</v-icon
              >
              <span
                >Solo las secciones marcadas serán generadas en el PDF
                final</span
              >
            </div>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="grey darken-2"
              class="px-4"
              @click="dialogSeccionesExportar = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="error"
              class="px-6 rounded-lg elevation-2 font-weight-bold"
              :disabled="
                seccionesSeleccionadas.length === 0 ||
                (listaPlantas.length > 0 && !plantaSeleccionada)
              "
              @click="confirmarExportarPDF"
            >
              Exportar PDF
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Visor del PDF Scrap generado -->
      <v-dialog
        v-model="dialogScrapPDF"
        persistent
        max-width="85%"
        transition="dialog-transition"
      >
        <v-card class="rounded-lg overflow-hidden">
          <v-toolbar color="#243042" dark dense flat>
            <v-icon left>mdi-file-pdf-box</v-icon>
            <v-toolbar-title class="text-subtitle-1 font-weight-bold">
              Reporte Scrap por Motivo (PDF)
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon small @click="cerrarScrapVisor" class="mr-n2">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-4">
            <!-- iframe del PDF -->
            <div
              v-if="ver_iframe_scrap && pdfScrapUrl"
              class="rounded-lg overflow-hidden border"
              style="border: 1px solid #e0e0e0"
            >
              <iframe
                id="ifrm_scrap"
                :src="pdfScrapUrl"
                style="width: 100%; height: 75vh; border: none; display: block"
              ></iframe>
            </div>
          </v-card-text>

          <v-card-actions class="px-4 pb-4 pt-0">
            <v-spacer></v-spacer>
            <v-btn text color="grey darken-1" @click="cerrarScrapVisor">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal Ver Imágenes y Recomendación de Scrap -->
      <Imagen
        ref="Imagen"
        :dialog="dialog_image"
        @dialog="dialog_image = $event"
        :Item="itemNeumaticoSeleccionado"
      />
    </v-col>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { axios2 as axios } from "@/interceptor/useApi";
import GraficoPie from "@/components/GraficoPie.vue";
import Imagen from "@/components/scrap/imagen.vue";
import global from "@/global";

export default {
  components: {
    GraficoPie,
    Imagen,
  },
  data() {
    return {
      global,
      Item: {
        year: null,
        month_init: null,
        month_end: null,
      },
      Meses: [],
      LabelsGraficoPie: [],
      DatosGraficoPie: [],
      ResumenMotivos: [],
      coloresGrafico: [
        "rgb(255, 99, 132)",
        "rgb(27, 205, 249)",
        "rgb(218, 247, 166)",
        "rgb(255, 205, 86)",
        "rgb(27, 216, 176)",
        "rgb(253, 152, 37)",
        "rgb(254, 243, 80)",
        "rgb(179, 241, 238)",
        "rgb(125, 254, 80)",
        "rgb(54, 162, 235)",
        "#E91E63",
        "#9C27B0",
        "#673AB7",
        "#3F51B5",
        "#2196F3",
        "#00BCD4",
        "#009688",
        "#4CAF50",
        "#8BC34A",
        "#CDDC39",
        "#FFEB3B",
        "#FFC107",
        "#FF9800",
        "#FF5722",
        "#795548",
        "#607D8B",
        "#F06292",
        "#BA68C8",
        "#4DD0E1",
        "#81C784",
      ],
      cargandoReporte: false,
      reporteConsultado: false,
      visualizarGrafico: false,
      existInfoScrap: false,
      dialogScrapPDF: false,
      dialogSeccionesExportar: false,
      seccionesSeleccionadas: [1, 2, 3],
      seccionesDisponibles: [
        {
          id: 1,
          titulo: "I.  Resumen de inspeccion de analisis de Scrap",
        },
        {
          id: 2,
          titulo: "II. Distribución Mensual por Motivo de Scrap",
        },
        {
          id: 3,
          titulo: "III. Resumen de Neumáticos Inspeccionados por Scrap",
        },
        {
          id: 4,
          titulo: "IV. Detalles de Neumáticos Inspeccionados en Scrap",
        },
        {
          id: 5,
          titulo: "V. Recomendaciones",
        },
      ],
      listaPlantas: [],
      cargandoPlantas: false,
      plantaSeleccionada: null,
      loaderScrapPdf: false,
      loaderScrapPdfMensaje: "Preparando reporte...",
      ver_iframe_scrap: false,
      pdfScrapUrl: null,
      pdfBlobUrl: null,
      pdfScrap: null,
      pdfScrapPollingInterval: null,
      totalgeneral: 0,
      totales_motivo: [],
      searchNeumaticos: "",
      headersNeumaticos: [
        { text: "ID", value: "id", align: "center", width: 60 },
        { text: "Marca", value: "marca", align: "center", width: 85 },
        { text: "Medida", value: "medida", align: "center", width: 85 },
        { text: "Diseño", value: "disenio", align: "center", width: 85 },
        { text: "Serie", value: "num_serie", align: "center", width: 85 },
        { text: "DOT", value: "serie_cliente", align: "center", width: 75 },
        { text: "PR", value: "play_rating", align: "center", width: 60 },
        { text: "Estado", value: "nuevo", align: "center", width: 90 },
        {
          text: "Empresa Reenca.",
          value: "empresa_reenc",
          align: "center",
          width: 100,
        },
        { text: "Izq.", value: "izq", align: "center", width: 60 },
        { text: "Der.", value: "der", align: "center", width: 60 },
        {
          text: "Motivo de retiro",
          value: "motivo_retiro",
          align: "left",
          width: 160,
        },
        { text: "Posible causa", value: "motivo", align: "left", width: 160 },
        { text: "Empresa", value: "cliente", align: "left", width: 140 },
        {
          text: "NSD ORI.",
          value: "remanente_original",
          align: "center",
          width: 80,
        },
        {
          text: "NSD FIN.",
          value: "remanente_final",
          align: "center",
          width: 80,
        },
        {
          text: "NSD REENC.",
          value: "remanente_limite",
          align: "center",
          width: 80,
        },
        { text: "$ Precio", value: "precio", align: "center", width: 80 },
        {
          text: "$ Pérdida por falla",
          value: "costo_perdido",
          align: "center",
          width: 95,
        },
        {
          text: "Imagen",
          value: "image",
          align: "center",
          width: 105,
          sortable: false,
        },
      ],
      dialog_image: false,
      itemNeumaticoSeleccionado: {},
    };
  },
  computed: {
    ...mapState("cliente", ["Cliente"]),
    ...mapState("reportes", [
      "NeumaticosScrapMesMotivo",
      "MotivosScrap",
      "NeumaticosScrap",
    ]),
    ...mapState("reporteconsolidado", ["Years"]),

    motivoMayorScrap() {
      if (
        !this.ResumenMotivos ||
        this.ResumenMotivos.length === 0 ||
        this.totalgeneral === 0
      ) {
        return null;
      }

      const mayor = this.ResumenMotivos[0];
      if (!mayor || mayor.cantidad <= 0) {
        return null;
      }

      return {
        motivo: mayor.motivo,
        cantidad: mayor.cantidad,
        porcentaje: mayor.porcentajeStr,
      };
    },
    costo_perdido_total() {
      if (!this.NeumaticosScrap || this.NeumaticosScrap.length === 0) {
        return 0;
      }

      return this.NeumaticosScrap.reduce((acumulador, neumatico) => {
        return acumulador + parseFloat(neumatico.costo_perdido || 0);
      }, 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    headersDistribucion() {
      const headers = [
        {
          text: "Mes",
          value: "nombre",
          align: "center",
          sortable: false,
          width: 95,
          class: "th-mes",
        },
      ];

      if (this.MotivosScrap && this.MotivosScrap.length > 0) {
        this.MotivosScrap.forEach((item) => {
          headers.push({
            text: item.motivo,
            value: "cantidad_motivo_" + item.id,
            align: "center",
            sortable: false,
            width: 85,
            class: "th-motivo",
          });
        });
      }

      headers.push(
        {
          text: "Total general",
          value: "total_mes",
          align: "center",
          sortable: false,
          width: 75,
          class: "th-total",
        },
        {
          text: "% Part.",
          value: "porcentaje_mes",
          align: "center",
          sortable: false,
          width: 70,
          class: "th-porcentaje",
        },
      );

      return headers;
    },

    itemsDistribucion() {
      if (
        !this.NeumaticosScrapMesMotivo ||
        this.NeumaticosScrapMesMotivo.length === 0
      ) {
        return [];
      }
      return this.NeumaticosScrapMesMotivo.map((item) => {
        const row = { ...item };
        if (this.MotivosScrap && this.MotivosScrap.length > 0) {
          this.MotivosScrap.forEach((m) => {
            row["cantidad_motivo_" + m.id] =
              item["cantidad_motivo_" + m.id] !== undefined &&
              item["cantidad_motivo_" + m.id] !== null
                ? item["cantidad_motivo_" + m.id]
                : 0;
          });
        }
        row.porcentaje_mes = this.calcularPorcentaje(item.total_mes);
        return row;
      });
    },
    todasSeccionesSeleccionadas() {
      const todas = this.seccionesDisponibles.map((sec) => sec.id);
      return todas.every((id) => this.seccionesSeleccionadas.includes(id));
    },
  },
  watch: {
    Item: {
      deep: true,
      handler() {
        this.reporteConsultado = false;
      },
    },
  },
  methods: {
    ...mapActions("cliente", ["ObtenerDatosCliente"]),
    ...mapActions("reportes", ["DatosReporteAnalisisScrap"]),
    ...mapActions("reporteconsolidado", ["cargarAnios"]),

    verImagen(item) {
      this.itemNeumaticoSeleccionado = item;
      this.dialog_image = true;
    },

    onMeses: async function (year) {
      this.Item.month_init = null;
      this.Item.month_end = null;
      this.visualizarGrafico = false;
      this.existInfoScrap = false;
      this.totales_motivo = [];
      this.totalgeneral = 0;
      this.LabelsGraficoPie = [];
      this.DatosGraficoPie = [];
      this.ResumenMotivos = [];
      this.Meses = [];

      if (!year) return;

      try {
        const data = {
          id_cliente: localStorage.getItem("idcliente"),
          year: year,
        };
        const response = await axios.post("reporte/meses", data);
        if (
          response.data &&
          response.data.success &&
          response.data.success.datos
        ) {
          this.Meses = response.data.success.datos.map((element) => ({
            numero_mes: String(element.numero_mes),
            mes: element.mes,
            text: element.mes,
            value: String(element.numero_mes),
          }));
        }
      } catch (error) {
        console.error("Error al obtener meses:", error);
      }
    },

    consultarReporte: async function () {
      if (!this.Item.year || !this.Item.month_init) {
        return;
      }

      this.visualizarGrafico = false;
      this.existInfoScrap = false;
      this.totales_motivo = [];
      this.totalgeneral = 0;
      this.LabelsGraficoPie = [];
      this.DatosGraficoPie = [];
      this.ResumenMotivos = [];
      this.cargandoReporte = true;
      this.reporteConsultado = false;

      try {
        const payload = {
          year: this.Item.year,
          month_init: this.Item.month_init,
          month_end: this.Item.month_end || this.Item.month_init,
        };

        await this.DatosReporteAnalisisScrap(payload);
        this.reporteConsultado = true;

        if (
          this.NeumaticosScrapMesMotivo &&
          this.NeumaticosScrapMesMotivo.length > 0
        ) {
          this.NeumaticosScrapMesMotivo.forEach((element) => {
            this.totalgeneral += element.total_mes;
          });

          this.MotivosScrap.forEach((element1) => {
            let cantidad = 0;
            this.NeumaticosScrapMesMotivo.forEach((element2) => {
              cantidad += element2["cantidad_motivo_" + element1.id] || 0;
            });
            this.totales_motivo.push(cantidad);
          });

          let resumen = [];
          this.MotivosScrap.forEach((element1, index) => {
            let cantidad = this.totales_motivo[index] || 0;
            let porcentajeStr = this.calcularPorcentaje(cantidad);
            let total = this.totalgeneral == 0 ? 1 : this.totalgeneral;
            let porcentajeNum = parseFloat(
              ((cantidad / total) * 100).toFixed(2),
            );

            resumen.push({
              id: element1.id,
              motivo: element1.motivo,
              cantidad: cantidad,
              porcentajeStr: porcentajeStr,
              porcentajeNum: porcentajeNum,
            });
          });

          // Ordenar de mayor a menor por cantidad
          resumen.sort((a, b) => b.cantidad - a.cantidad);

          this.ResumenMotivos = resumen;

          resumen.forEach((item) => {
            this.LabelsGraficoPie.push(
              item.motivo + " (" + item.porcentajeStr + ")",
            );
            this.DatosGraficoPie.push(item.porcentajeNum);
          });

          if (this.NeumaticosScrap.length > 0) {
            this.existInfoScrap = true;
          }

          await this.$nextTick();
          this.visualizarGrafico = true;
        } else {
          this.visualizarGrafico = false;
          this.existInfoScrap = false;
        }
      } catch (error) {
        console.error("Error al consultar reporte:", error);
      } finally {
        this.cargandoReporte = false;
      }
    },

    calcularPorcentaje: function (cantidad) {
      let total = this.totalgeneral == 0 ? 1 : this.totalgeneral;
      let valor = (cantidad / total) * 100;

      if (valor != 100) {
        valor = valor.toFixed(2);
      }
      return valor + "%";
    },

    obtenerColorMotivo(index) {
      return this.coloresGrafico[index % this.coloresGrafico.length];
    },

    _json_to_query_string: function (json) {
      json = Object.keys(json).map((item) => {
        return (
          item +
          "=" +
          (json[item] !== undefined && json[item] !== null ? json[item] : "")
        );
      });
      return json.join("&");
    },

    exportarAExcel: async function () {
      try {
        const url =
          axios.defaults.baseURL +
          "excel/reportescrapmotivo?" +
          this._json_to_query_string({
            id_cliente: localStorage.getItem("idcliente"),
            year: this.Item.year,
            month_init: this.Item.month_init,
            month_end: this.Item.month_end || this.Item.month_init,
            month1: this.Item.month_init,
            month2: this.Item.month_end || this.Item.month_init,
          });

        const response = await axios({
          url: url,
          method: "GET",
          responseType: "blob",
        });

        // Obtener nombre de archivo desde Content-Disposition
        let nombre_archivo = "reporte.xlsx";
        const disposition = response.headers["content-disposition"];

        if (disposition) {
          // Priorizar UTF-8 si está disponible
          const utf8Match = disposition.match(/filename\*=UTF-8''([^;\n]*)/i);
          const asciiMatch = disposition.match(/filename="?([^;\n"]+)"?/i);

          if (utf8Match && utf8Match[1]) {
            nombre_archivo = decodeURIComponent(utf8Match[1]);
          } else if (asciiMatch && asciiMatch[1]) {
            nombre_archivo = asciiMatch[1];
          }
        }

        // Si el blob es HTML (error), mostrar alerta
        if (response.data.type === "text/html") {
          const text = await response.data.text();
          const res = JSON.parse(text);
          if (!res.exito) {
            alert(res.mensaje || "Ocurrió un error al generar el archivo.");
            return;
          }
        } else {
          // Descargar archivo
          const blob = new Blob([response.data]);
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", nombre_archivo);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      } catch (error) {
        this.loadingExcel = false;
        this.errorMessage = error.response?.data || "Error inesperado";
        console.error("Error al exportar a Excel:", error);
      }
    },

    generarScrapPDF: async function () {
      if (!this.Item.year || !this.Item.month_init) {
        return;
      }

      // Limpiar estado previo
      this.ver_iframe_scrap = false;
      this.pdfScrapUrl = null;
      this.loaderScrapPdf = true;
      this.loaderScrapPdfMensaje = "Preparando reporte...";
      this.dialogScrapPDF = false;

      // Limpiar polling anterior si existía
      if (this.pdfScrapPollingInterval) {
        clearInterval(this.pdfScrapPollingInterval);
        this.pdfScrapPollingInterval = null;
      }

      const data = {
        id_cliente: localStorage.getItem("idcliente"),
        id_usuario: localStorage.getItem("id"),
        year: this.Item.year,
        month_init: this.Item.month_init,
        month_end: this.Item.month_end || this.Item.month_init,
        month1: this.Item.month_init,
        month2: this.Item.month_end || this.Item.month_init,
        secciones_reporte: this.seccionesSeleccionadas,
        nombre_sede: this.plantaSeleccionada,
      };

      try {
        // PASO 1: Guardar parámetros y obtener el UUID
        const savePdfResponse = await axios.post("reporte/scrap/savePdf", data);
        const uuid =
          savePdfResponse.data && savePdfResponse.data.datos
            ? savePdfResponse.data.datos.uuid
            : savePdfResponse.data.uuid;
        this.pdfScrap = savePdfResponse.data.datos || savePdfResponse.data;

        // PASO 2: Iniciar el job en background
        this.loaderScrapPdfMensaje =
          "Generando reporte PDF en segundo plano...";
        await axios.get("reporte/scrap/pdf/" + uuid);

        // PASO 3: Polling cada 4 segundos para verificar cuándo está listo
        this.pdfScrapPollingInterval = setInterval(async () => {
          try {
            const statusResponse = await axios.get(
              "reporte/scrap/pdf/status/" + uuid,
            );
            const statusData = statusResponse.data;

            if (statusData.status === "done" && statusData.url) {
              // PDF listo → detener polling y descargar blob atómico
              clearInterval(this.pdfScrapPollingInterval);
              this.pdfScrapPollingInterval = null;
              this.loaderScrapPdfMensaje = "Cargando documento en el visor...";

              try {
                const downloadUrl = "reporte/scrap/pdf/descargar/" + uuid;
                const pdfResponse = await axios.get(downloadUrl, {
                  responseType: "blob",
                });

                if (this.pdfBlobUrl) {
                  URL.revokeObjectURL(this.pdfBlobUrl);
                }

                const blob = new Blob([pdfResponse.data], {
                  type: "application/pdf",
                });
                this.pdfBlobUrl = URL.createObjectURL(blob);
                this.pdfScrapUrl = this.pdfBlobUrl;
                this.loaderScrapPdf = false;
                this.ver_iframe_scrap = true;
                this.dialogScrapPDF = true;
              } catch (blobError) {
                console.error(
                  "Error al descargar blob del PDF scrap:",
                  blobError,
                );
                this.loaderScrapPdf = false;
                this.dialogScrapPDF = false;
                if (this.$alertify) {
                  this.$alertify.error(
                    "No se pudo cargar el archivo PDF generado.",
                  );
                }
              }
            } else if (statusData.status === "failed") {
              // Error en la generación
              clearInterval(this.pdfScrapPollingInterval);
              this.pdfScrapPollingInterval = null;
              this.loaderScrapPdf = false;
              this.loaderScrapPdfMensaje = "Error al generar el reporte.";
              console.error("Error generando PDF scrap:", statusData.error);
              if (this.$alertify) {
                this.$alertify.error(
                  statusData.error ||
                    "Ocurrió un error al generar el reporte PDF. Intente nuevamente.",
                );
              }
              this.dialogScrapPDF = false;
            } else {
              // Aún procesando
              this.loaderScrapPdfMensaje =
                "Generando reporte... por favor espere.";
            }
          } catch (pollError) {
            console.error("Error en polling scrap PDF:", pollError);
            clearInterval(this.pdfScrapPollingInterval);
            this.pdfScrapPollingInterval = null;
            this.loaderScrapPdf = false;
            this.dialogScrapPDF = false;
            if (this.$alertify) {
              this.$alertify.error(
                "Error de conexión al consultar el estado del reporte.",
              );
            }
          }
        }, 4000);
      } catch (error) {
        console.error("Error al iniciar generación de PDF scrap:", error);
        this.loaderScrapPdf = false;
        this.dialogScrapPDF = false;
        if (this.$alertify) {
          this.$alertify.error(
            "No se pudo iniciar la generación del reporte. Intente nuevamente.",
          );
        }
      }
    },

    cancelarScrapPDF: function () {
      if (this.pdfScrap && this.pdfScrap.uuid) {
        axios
          .post("reporte/scrap/pdf/cancelar/" + this.pdfScrap.uuid)
          .catch((err) => {
            console.error("Error al cancelar reporte scrap en backend:", err);
          });
      }
    },

    cerrarScrapVisor: function () {
      // Limpiar polling si existe
      if (this.pdfScrapPollingInterval) {
        clearInterval(this.pdfScrapPollingInterval);
        this.pdfScrapPollingInterval = null;
      }

      // Cancelar job en backend si estaba en proceso
      if (this.loaderScrapPdf) {
        this.cancelarScrapPDF();
      }

      if (this.pdfBlobUrl) {
        URL.revokeObjectURL(this.pdfBlobUrl);
        this.pdfBlobUrl = null;
      }

      this.dialogScrapPDF = false;
      this.ver_iframe_scrap = false;
      this.pdfScrapUrl = null;
      this.loaderScrapPdf = false;
      this.loaderScrapPdfMensaje = "Generando reporte...";
    },

    toggleSeleccionarTodas() {
      const todas = this.seccionesDisponibles.map((sec) => sec.id);
      if (this.todasSeccionesSeleccionadas) {
        this.seccionesSeleccionadas = [];
      } else {
        this.seccionesSeleccionadas = [...todas];
      }
    },

    marcarTodasSecciones() {
      const todas = this.seccionesDisponibles.map((sec) => sec.id);
      this.seccionesSeleccionadas = [...todas];
    },

    toggleSeccion(id) {
      const index = this.seccionesSeleccionadas.indexOf(id);
      if (index > -1) {
        this.seccionesSeleccionadas = this.seccionesSeleccionadas.filter(
          (item) => item !== id,
        );
      } else {
        this.seccionesSeleccionadas = [...this.seccionesSeleccionadas, id];
      }
    },

    abrirModalSeccionesExportar: async function () {
      this.marcarTodasSecciones();
      this.dialogSeccionesExportar = true;
      await this.obtenerPlantas();
    },

    obtenerPlantas: async function () {
      this.cargandoPlantas = true;
      try {
        const response = await axios.post("plantas/index", {
          id_cliente: localStorage.getItem("idcliente"),
        });
        if (
          response.data &&
          response.data.success &&
          response.data.success.resultado
        ) {
          this.listaPlantas = response.data.success.resultado;
          if (!this.plantaSeleccionada && this.listaPlantas.length > 0) {
            this.plantaSeleccionada = this.listaPlantas[0].nombre;
          }
        }
      } catch (error) {
        console.error("Error al cargar plantas:", error);
      } finally {
        this.cargandoPlantas = false;
      }
    },

    confirmarExportarPDF() {
      if (
        !this.seccionesSeleccionadas ||
        this.seccionesSeleccionadas.length === 0
      ) {
        if (this.$alertify) {
          this.$alertify.error(
            "Debe seleccionar al menos una sección para exportar.",
          );
        }
        return;
      }
      this.dialogSeccionesExportar = false;
      this.generarScrapPDF();
    },
  },
  mounted() {
    this.ObtenerDatosCliente();
    this.cargarAnios();
  },
  beforeDestroy() {
    if (this.pdfScrapPollingInterval) {
      clearInterval(this.pdfScrapPollingInterval);
      this.pdfScrapPollingInterval = null;
    }
    if (this.loaderScrapPdf) {
      this.cancelarScrapPDF();
    }
    if (this.pdfBlobUrl) {
      URL.revokeObjectURL(this.pdfBlobUrl);
      this.pdfBlobUrl = null;
    }
  },
};
</script>
<style scoped>
table {
  border-collapse: collapse;
}

td {
  vertical-align: top;
}

.border {
  /* border-style: solid; */
  border-width: 1px;
}

.border-bottom {
  border-bottom: solid;
  border-width: 1px;
}

.border-top {
  border-top: solid;
  border-width: 1px;
}

.border-left {
  border-left: solid;
  border-width: 1px;
}

.border-right {
  border-right: solid;
  border-width: 1px;
}

.no-border {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
}

.no-border-left {
  border-left: none;
}

.no-border-right {
  border-right: none;
}

.texto-cen {
  text-align: center;
}

.texto-izq {
  text-align: left;
}

.texto-just {
  text-align: justify;
}

.inline {
  display: inline-block;
}

.texto-arriba {
  vertical-align: text-top;
  vertical-align: top;
}

.letra-6 {
  font-size: 6pt;
}

.letra-7 {
  font-size: 7pt;
}

.letra-8 {
  font-size: 8pt;
}

.letra-9 {
  font-size: 9pt;
}

.letra-10 {
  font-size: 10pt;
}

.letra-11 {
  font-size: 11pt;
}

.letra-12 {
  font-size: 12pt;
}

.letra-14 {
  font-size: 14pt;
}

.letra-15 {
  font-size: 15pt;
}
.bg-celda-azul {
  background: #91e3da;
}

.bg-celda-amarilla {
  background: #faec5c;
  /*color:#EDDF04;*/
}

.bg-celda-verde {
  background: #a8fa6f;
}

.bg-celda-roja {
  background: #f55f50;
}

.tabla-distribucion-moderna {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.tabla-distribucion-moderna ::v-deep .v-data-table__wrapper {
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: #b0bec5 #f5f5f5;
}

.tabla-distribucion-moderna ::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.tabla-distribucion-moderna
  ::v-deep
  .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 3px;
}

.tabla-distribucion-moderna
  ::v-deep
  .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #b0bec5;
  border-radius: 3px;
}

.tabla-distribucion-moderna
  ::v-deep
  .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #78909c;
}

.tabla-distribucion-moderna ::v-deep table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}

.tabla-distribucion-moderna ::v-deep thead th {
  background-color: #545554 !important;
  color: #ffffff !important;
  font-size: 10.5px !important;
  font-weight: 600 !important;
  text-align: center;
  white-space: normal !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  hyphens: auto;
  line-height: 1.2 !important;
  padding: 8px 4px !important;
  height: auto !important;
  min-height: 42px !important;
  vertical-align: middle !important;
  border-right: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-bottom: 2px solid rgba(0, 0, 0, 0.15) !important;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}

.tabla-distribucion-moderna ::v-deep thead th.text-left,
.tabla-distribucion-moderna ::v-deep thead th.text-start {
  text-align: left !important;
}

.tabla-distribucion-moderna ::v-deep thead th.text-center {
  text-align: center !important;
}

.tabla-distribucion-moderna ::v-deep thead th.text-right,
.tabla-distribucion-moderna ::v-deep thead th.text-end {
  text-align: right !important;
}

.tabla-distribucion-moderna ::v-deep thead th span {
  display: inline-block;
  max-width: 100%;
  white-space: normal !important;
  word-break: break-word !important;
  line-height: 1.2;
}

.tabla-distribucion-moderna ::v-deep thead th:last-child {
  border-right: none !important;
}

.tabla-distribucion-moderna ::v-deep thead th.th-total,
.tabla-distribucion-moderna ::v-deep thead th.th-porcentaje {
  background-color: #3f403f !important;
  font-weight: 700 !important;
}

/* Sticky primera columna (Mes o ID) */
.tabla-distribucion-moderna ::v-deep thead th:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 4 !important;
  background-color: #3f403f !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.15);
}

.tabla-distribucion-moderna ::v-deep tbody tr td:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 2 !important;
  background-color: #ffffff;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.tabla-distribucion-moderna ::v-deep tbody tr:hover td:first-child {
  background-color: #f5f7fa !important;
}

.tabla-distribucion-moderna
  ::v-deep
  tbody
  tr.fila-total-general
  td:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 3 !important;
  background-color: #eceff1 !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.08);
}

.tabla-distribucion-moderna
  ::v-deep
  tbody
  tr.fila-porcentaje-general
  td:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 3 !important;
  background-color: #f8fafc !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.08);
}

.tabla-distribucion-moderna ::v-deep tbody td {
  border-right: 1px solid #edf2f7;
  border-bottom: 1px solid #edf2f7 !important;
  font-size: 11px;
  padding: 6px 4px !important;
  text-align: center;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.tabla-distribucion-moderna ::v-deep tbody td.text-left,
.tabla-distribucion-moderna ::v-deep tbody td.text-start {
  text-align: left !important;
}

.tabla-distribucion-moderna ::v-deep tbody td.text-center {
  text-align: center !important;
}

.tabla-distribucion-moderna ::v-deep tbody td.text-right,
.tabla-distribucion-moderna ::v-deep tbody td.text-end {
  text-align: right !important;
}

.tabla-distribucion-moderna ::v-deep tbody td:last-child {
  border-right: none;
}

.tabla-distribucion-moderna ::v-deep .v-data-footer {
  border-top: 1px solid #e0e0e0;
  font-size: 11px;
  padding: 4px 12px;
  background-color: #fafafa;
}

.tabla-distribucion-moderna ::v-deep .v-data-footer__select {
  margin-bottom: 0;
}

.tabla-distribucion-moderna ::v-deep .v-data-footer__pagination {
  font-size: 11px;
}

.tabla-distribucion-moderna
  ::v-deep
  tbody
  tr:hover:not(.fila-total-general):not(.fila-porcentaje-general) {
  background-color: #f8fafc !important;
}

.fila-total-general {
  background-color: #eceff1 !important;
  border-top: 2px solid #cfd8dc !important;
  border-bottom: 1px solid #cfd8dc !important;
}

.fila-total-general td {
  font-weight: 700 !important;
  font-size: 11px !important;
  border-right: 1px solid #cfd8dc !important;
  border-bottom: 1px solid #cfd8dc !important;
  color: #1e293b;
}

.fila-total-general td:last-child {
  border-right: none !important;
}

.fila-porcentaje-general {
  background-color: #f8fafc !important;
  border-bottom: 2px solid #cfd8dc !important;
}

.fila-porcentaje-general td {
  font-weight: 600 !important;
  font-size: 10.5px !important;
  border-right: 1px solid #e2e8f0 !important;
  border-bottom: 2px solid #cbd5e1 !important;
  color: #334155;
}

.fila-porcentaje-general td:last-child {
  border-right: none !important;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive::-webkit-scrollbar {
  height: 6px;
}
.table-responsive::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}
.table-responsive::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.toolbar-responsive .text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 600px) {
  .toolbar-responsive {
    height: 48px !important;
  }
}

/* Responsivo para tablets y pantallas medianas */
@media (max-width: 960px) {
  .tabla-distribucion-moderna ::v-deep thead th {
    font-size: 9.5px !important;
    padding: 6px 4px !important;
    min-height: 38px !important;
  }

  .tabla-distribucion-moderna ::v-deep tbody td {
    font-size: 10px !important;
    padding: 6px 4px !important;
  }

  .fila-total-general td,
  .fila-porcentaje-general td {
    font-size: 10px !important;
    padding: 6px 4px !important;
  }
}

/* Responsivo para móviles */
@media (max-width: 600px) {
  .tabla-distribucion-moderna ::v-deep thead th {
    font-size: 9.5px !important;
    padding: 6px 4px !important;
    line-height: 1.2 !important;
  }

  .tabla-distribucion-moderna ::v-deep tbody td {
    font-size: 10px !important;
    padding: 6px 4px !important;
  }

  .fila-total-general td,
  .fila-porcentaje-general td {
    font-size: 10px !important;
    padding: 6px 4px !important;
  }
}

#table {
  display: block; /* important */
  width: 100% !important;
  overflow-x: scroll;
}

.seccion-card-grupo {
  border-left: 4px solid #1976d2 !important;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

.seccion-card-grupo:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08) !important;
}

.subseccion-item {
  transition: background-color 0.15s ease;
}

.subseccion-item:hover {
  background-color: #f1f5f9;
}

.subseccion-selected {
  background-color: #eff6ff;
}

.seccion-card-simple {
  border-left: 4px solid #94a3b8 !important;
  transition: all 0.2s ease;
}

.seccion-card-simple:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08) !important;
}

.seccion-simple-selected {
  border-left-color: #1976d2 !important;
  background-color: #fafafa;
}

/* =========================================================
   UI/UX STYLES - REPORTE SCRAP POR MOTIVO
   Basado en ReporteRemanenteRodadoVehiculo.vue
   ========================================================= */

.scrap-motivo-wrapper {
  background-color: #f8fafc;
  min-height: 100%;
}

/* Botón Volver */
.back-btn {
  font-weight: 700;
  letter-spacing: 0.3px;
  border-radius: 8px;
  text-transform: none;
  transition: all 0.2s ease;
}

.back-btn:hover {
  transform: translateX(-2px);
}

/* Card y Header Modernos */
.modern-report-card {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden;
  background: #ffffff !important;
}

.report-header-banner {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.header-main-info {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-help-btn {
  flex: 0 0 auto;
  flex-shrink: 0;
  white-space: nowrap;
}

.header-icon-box {
  width: 42px;
  height: 42px;
  min-width: 42px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.header-company-title {
  font-size: 1.05rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-report-subtitle {
  color: #94a3b8;
  font-size: 0.78rem;
  font-weight: 500;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.summary-header-chip {
  background: rgba(255, 255, 255, 0.14) !important;
  color: #ffffff !important;
  border: 1px solid rgba(255, 255, 255, 0.22) !important;
  font-weight: 500;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
  transform: scale(1.06);
}

/* Card interna de Filtros */
.dashboard-chart-card {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff;
  transition: transform 0.2s ease, box-shadow 0.25s ease, border-color 0.2s ease;
}

.dashboard-chart-card:hover {
  border-color: #cbd5e1 !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05) !important;
}

.chart-subtitle-bar {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.815rem;
  line-height: 1.35;
  min-height: 42px;
}

/* Campos de Formulario */
.field-custom ::v-deep .v-input__slot {
  background: #f8fafc !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.field-custom ::v-deep .v-input__slot:hover {
  background: #ffffff !important;
}

.field-custom ::v-deep.v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}

.field-readonly ::v-deep .v-input__slot {
  background: #f1f5f9 !important;
  cursor: not-allowed;
}

.filter-action-btn {
  border-radius: 8px !important;
  letter-spacing: 0.3px;
  text-transform: none;
  font-size: 0.875rem !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
}

.border-top-light {
  border-top: 1px solid #e2e8f0;
}

/* Estados Vacío y Carga */
.chart-empty-state {
  min-height: 280px;
  background: #f8fafc;
  border: 1.5px dashed #cbd5e1;
}

.empty-state-icon-circle {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-loading-state {
  min-height: 280px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.max-width-480 {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
}

/* Loading Overlay y Card con Glassmorphism (Idéntico a Reporte Consolidado) */
.v-overlay--active.consulta-overlay-container {
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.consulta-loader-card {
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 20px 35px -5px rgba(0, 0, 0, 0.25),
    0 10px 15px -5px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  padding: 32px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 320px;
  max-width: 440px;
  text-align: center;
  animation: fadeInScale 0.25s ease-out;
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.94);
  }
  to {
    opacity: 1;
  }
}

.consulta-loader-spinner-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.consulta-loader-inner-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.consulta-loader-title {
  font-size: 1.1rem;
  color: #1e293b;
  letter-spacing: -0.2px;
}

.consulta-loader-subtitle {
  font-size: 0.84rem;
  color: #64748b;
  line-height: 1.4;
}

.consulta-loader-status-bar {
  width: 100%;
  max-width: 220px;
  border-radius: 4px;
  overflow: hidden;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .report-header-banner {
    padding: 12px 14px;
    gap: 8px;
  }

  .header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
  }

  .header-company-title {
    font-size: 0.85rem !important;
  }

  .header-report-subtitle {
    font-size: 0.68rem !important;
  }
}
</style>
